// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from "./core/CancelablePromise";
import { OpenAPI } from "./core/OpenAPI";
import { request as __request } from "./core/request";
import type {
  RestRestCheckRetrieveResponse,
  CurrentUserLoginData,
  CurrentUserLoginResponse,
  CurrentUserLogoutResponse,
  UsersListData,
  UsersListResponse,
  UsersCreateData,
  UsersCreateResponse,
  UsersRetrieveData,
  UsersRetrieveResponse,
  UsersUpdateData,
  UsersUpdateResponse,
  UsersPartialUpdateData,
  UsersPartialUpdateResponse,
  UsersDestroyData,
  UsersDestroyResponse,
  GetAccountUsersData,
  GetAccountUsersResponse,
  CreateUserData,
  CreateUserResponse2,
  UpdateUserData,
  UpdateUserResponse,
  DeleteUserData,
  DeleteUserResponse,
  BulkUpdateUserLimitsData,
  BulkUpdateUserLimitsResponse,
  BulkValidateUsersData,
  BulkValidateUsersResponse2,
  BulkCreateUsersData,
  BulkCreateUsersResponse2,
  GetHistoricalUsageData,
  GetHistoricalUsageResponse,
  AccountsListData,
  AccountsListResponse,
  AccountsCreateData,
  AccountsCreateResponse,
  AccountsRetrieveData,
  AccountsRetrieveResponse,
  AccountsUpdateData,
  AccountsUpdateResponse,
  AccountsDestroyData,
  AccountsDestroyResponse,
  GetSiteConfData,
  GetSiteConfResponse,
  UpdateSiteConfData,
  UpdateSiteConfResponse,
  UserFilterKeywordsResponse,
  AccountFilterKeywordsResponse,
  FirstgenAfterImagenData,
  FirstgenAfterImagenResponse,
  ClearAfterImagesData,
  ClearAfterImagesResponse,
  RegenAfterImagesData,
  RegenAfterImagesResponse,
  RoomDesignsItemRemovalClearCreateData,
  RoomDesignsItemRemovalClearCreateResponse,
  RoomDesignsItemRemovalProcessCreateResponse,
  RoomDesignsItemRemovalRegenCreateData,
  RoomDesignsItemRemovalRegenCreateResponse,
} from "./types.gen";

export class RestService {
  /**
   * Check REST API
   * This endpoint checks if the REST API is working.
   * @returns Message
   * @throws ApiError
   */
  public static restRestCheckRetrieve(): CancelablePromise<RestRestCheckRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/rest/rest-check/",
    });
  }
}

export class CurrentUserService {
  /**
   * Log in current user
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Message
   * @throws ApiError
   */
  public static currentUserLogin(
    data: CurrentUserLoginData = {},
  ): CancelablePromise<CurrentUserLoginResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/login",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Log out current user
   * @returns Message
   * @throws ApiError
   */
  public static currentUserLogout(): CancelablePromise<CurrentUserLogoutResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/logout",
    });
  }
}

export class UsersService {
  /**
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.page Selected page of result.
   * @param data.searchKeyword Search keyword.
   * @param data.contractStartDateSort ContractStartDate sort order.
   * @param data.contractEndDateSort ContractEndDate sort order.
   * @param data.corporateNameFilter Corporate Name filter keyword.
   * @param data.storeNameFilter Store Name filter keyword.
   * @param data.registrationRouteFilter Registration Route filter keyword.
   * @param data.planTypesFilter Plan Type filter keyword.
   * @param data.isActiveFilter Is Active filter keyword.
   * @returns PaginatedUserList
   * @throws ApiError
   */
  public static usersList(
    data: UsersListData = {},
  ): CancelablePromise<UsersListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/users/",
      query: {
        limit: data.limit,
        page: data.page,
        search_keyword: data.searchKeyword,
        contract_start_date_sort: data.contractStartDateSort,
        contract_end_date_sort: data.contractEndDateSort,
        corporate_name_filter: data.corporateNameFilter,
        store_name_filter: data.storeNameFilter,
        registration_route_filter: data.registrationRouteFilter,
        plan_types_filter: data.planTypesFilter,
        is_active_filter: data.isActiveFilter,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns User
   * @throws ApiError
   */
  public static usersCreate(
    data: UsersCreateData,
  ): CancelablePromise<UsersCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/users/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this user.
   * @returns User
   * @throws ApiError
   */
  public static usersRetrieve(
    data: UsersRetrieveData,
  ): CancelablePromise<UsersRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/users/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this user.
   * @param data.requestBody
   * @returns User
   * @throws ApiError
   */
  public static usersUpdate(
    data: UsersUpdateData,
  ): CancelablePromise<UsersUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/users/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this user.
   * @param data.requestBody
   * @returns User
   * @throws ApiError
   */
  public static usersPartialUpdate(
    data: UsersPartialUpdateData,
  ): CancelablePromise<UsersPartialUpdateResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/users/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this user.
   * @returns Message
   * @throws ApiError
   */
  public static usersDestroy(
    data: UsersDestroyData,
  ): CancelablePromise<UsersDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/users/{id}/",
      path: {
        id: data.id,
      },
    });
  }
}

export class AccountUsersService {
  /**
   * @param data The data for the request.
   * @param data.accountId
   * @returns AccountUsersResponse
   * @throws ApiError
   */
  public static getAccountUsers(
    data: GetAccountUsersData,
  ): CancelablePromise<GetAccountUsersResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/account-users/",
      query: {
        account_id: data.accountId,
      },
    });
  }

  /**
   * 新規ユーザーを作成する
   * @param data The data for the request.
   * @param data.requestBody
   * @returns CreateUserResponse
   * @throws ApiError
   */
  public static createUser(
    data: CreateUserData,
  ): CancelablePromise<CreateUserResponse2> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/account-users/",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "入力値不正エラー",
        500: "サーバーエラー",
      },
    });
  }

  /**
   * ユーザー情報を更新する
   * @param data The data for the request.
   * @param data.requestBody
   * @returns GeneralUser
   * @throws ApiError
   */
  public static updateUser(
    data: UpdateUserData,
  ): CancelablePromise<UpdateUserResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/account-users/update/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * ユーザーを削除する
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static deleteUser(
    data: DeleteUserData,
  ): CancelablePromise<DeleteUserResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/account-users/delete/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * ユーザーの個別上限を一括更新する
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static bulkUpdateUserLimits(
    data: BulkUpdateUserLimitsData,
  ): CancelablePromise<BulkUpdateUserLimitsResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/account-users/bulk-update-limits/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * ユーザーデータを一括バリデーション（登録はしない）
   * @param data The data for the request.
   * @param data.requestBody
   * @returns BulkValidateUsersResponse
   * @throws ApiError
   */
  public static bulkValidateUsers(
    data: BulkValidateUsersData,
  ): CancelablePromise<BulkValidateUsersResponse2> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/account-users/bulk-validate/",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "入力値不正エラー",
        500: "サーバーエラー",
      },
    });
  }

  /**
   * ユーザーを一括作成する（バリデーション済み前提、少数ずつ呼び出す）
   * @param data The data for the request.
   * @param data.requestBody
   * @returns BulkCreateUsersResponse
   * @throws ApiError
   */
  public static bulkCreateUsers(
    data: BulkCreateUsersData,
  ): CancelablePromise<BulkCreateUsersResponse2> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/account-users/bulk-create/",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "入力値不正エラー",
        500: "サーバーエラー",
      },
    });
  }

  /**
   * 指定期間のユーザーごとの使用回数と個別上限を取得する
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static getHistoricalUsage(
    data: GetHistoricalUsageData,
  ): CancelablePromise<GetHistoricalUsageResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/account-users/historical-usage/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class AccountsService {
  /**
   * Account一覧取得用のビュー
   * @param data The data for the request.
   * @param data.limit Number of results to return per page.
   * @param data.page Selected page of result.
   * @param data.searchKeyword Search keyword.
   * @param data.contractStartDateSort ContractStartDate sort order.
   * @param data.contractEndDateSort ContractEndDate sort order.
   * @param data.corporateNameFilter Corporate Name filter keyword.
   * @param data.storeNameFilter Store Name filter keyword.
   * @param data.registrationRouteFilter Registration Route filter keyword.
   * @param data.planTypesFilter Plan Type filter keyword.
   * @param data.isActiveFilter Is Active filter keyword.
   * @returns PaginatedAccountList
   * @throws ApiError
   */
  public static accountsList(
    data: AccountsListData = {},
  ): CancelablePromise<AccountsListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/accounts/",
      query: {
        limit: data.limit,
        page: data.page,
        search_keyword: data.searchKeyword,
        contract_start_date_sort: data.contractStartDateSort,
        contract_end_date_sort: data.contractEndDateSort,
        corporate_name_filter: data.corporateNameFilter,
        store_name_filter: data.storeNameFilter,
        registration_route_filter: data.registrationRouteFilter,
        plan_types_filter: data.planTypesFilter,
        is_active_filter: data.isActiveFilter,
      },
    });
  }

  /**
   * Account新規作成
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Account
   * @throws ApiError
   */
  public static accountsCreate(
    data: AccountsCreateData,
  ): CancelablePromise<AccountsCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/accounts/",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * Account詳細を取得
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this account.
   * @returns Account
   * @throws ApiError
   */
  public static accountsRetrieve(
    data: AccountsRetrieveData,
  ): CancelablePromise<AccountsRetrieveResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/accounts/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Account更新
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this account.
   * @param data.requestBody
   * @returns Account
   * @throws ApiError
   */
  public static accountsUpdate(
    data: AccountsUpdateData,
  ): CancelablePromise<AccountsUpdateResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/accounts/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this account.
   * @returns Message
   * @throws ApiError
   */
  public static accountsDestroy(
    data: AccountsDestroyData,
  ): CancelablePromise<AccountsDestroyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/accounts/{id}/",
      path: {
        id: data.id,
      },
    });
  }
}

export class SiteConfService {
  /**
   * Get site config
   * @param data The data for the request.
   * @param data.key Config key
   * @returns SiteConfig
   * @throws ApiError
   */
  public static getSiteConf(
    data: GetSiteConfData = {},
  ): CancelablePromise<GetSiteConfResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/site_conf",
      query: {
        key: data.key,
      },
    });
  }

  /**
   * Update site config
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Message
   * @throws ApiError
   */
  public static updateSiteConf(
    data: UpdateSiteConfData = {},
  ): CancelablePromise<UpdateSiteConfResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/site_conf_update",
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class UserFilterKeywordsService {
  /**
   * Get lists of keywords for filtering users
   * @returns FilterKeywords
   * @throws ApiError
   */
  public static userFilterKeywords(): CancelablePromise<UserFilterKeywordsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/user_filter_keywords",
    });
  }
}

export class AccountFilterKeywordsService {
  /**
   * Get lists of keywords for filtering accounts
   * @returns FilterKeywords
   * @throws ApiError
   */
  public static accountFilterKeywords(): CancelablePromise<AccountFilterKeywordsResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/account_filter_keywords",
    });
  }
}

export class RoomDesignService {
  /**
   * Post an image for new room design
   * @param data The data for the request.
   * @param data.formData
   * @returns unknown
   * @throws ApiError
   */
  public static firstgenAfterImagen(
    data: FirstgenAfterImagenData = {},
  ): CancelablePromise<FirstgenAfterImagenResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/firstgen_after_image",
      formData: data.formData,
      mediaType: "multipart/form-data",
    });
  }

  /**
   * Clear after images for selected before image
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this before image.
   * @returns unknown
   * @throws ApiError
   */
  public static clearAfterImages(
    data: ClearAfterImagesData,
  ): CancelablePromise<ClearAfterImagesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/clear_after_images/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * Regenerate after images for selected before image with optional style parameters
   * @param data The data for the request.
   * @param data.id A unique integer value identifying this before image.
   * @param data.requestBody
   * @returns unknown
   * @throws ApiError
   */
  public static regenAfterImages(
    data: RegenAfterImagesData,
  ): CancelablePromise<RegenAfterImagesResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/regen_after_images/{id}/",
      path: {
        id: data.id,
      },
      body: data.requestBody,
      mediaType: "application/json",
    });
  }
}

export class RoomDesignsService {
  /**
   * 処理後画像をクリアするビュー
   * @param data The data for the request.
   * @param data.id
   * @returns unknown No response body
   * @throws ApiError
   */
  public static roomDesignsItemRemovalClearCreate(
    data: RoomDesignsItemRemovalClearCreateData,
  ): CancelablePromise<RoomDesignsItemRemovalClearCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/room-designs/item-removal/clear/{id}/",
      path: {
        id: data.id,
      },
    });
  }

  /**
   * 家具削除処理を実行するビュー
   * @returns unknown No response body
   * @throws ApiError
   */
  public static roomDesignsItemRemovalProcessCreate(): CancelablePromise<RoomDesignsItemRemovalProcessCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/room-designs/item-removal/process/",
    });
  }

  /**
   * 処理後画像を再生成するビュー
   * @param data The data for the request.
   * @param data.id
   * @returns unknown No response body
   * @throws ApiError
   */
  public static roomDesignsItemRemovalRegenCreate(
    data: RoomDesignsItemRemovalRegenCreateData,
  ): CancelablePromise<RoomDesignsItemRemovalRegenCreateResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/room-designs/item-removal/regen/{id}/",
      path: {
        id: data.id,
      },
    });
  }
}
